import { render, staticRenderFns } from "./DeviceFeedback.vue?vue&type=template&id=0a436fdf&scoped=true&"
import script from "./DeviceFeedback.vue?vue&type=script&lang=js&"
export * from "./DeviceFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a436fdf",
  null
  
)

export default component.exports